import React from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Button, colors, CardHeader, Divider } from '@mui/material';

import { GetSiteString } from '../../../actions/UploadsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const SiteString = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const _generate = () => {
		dispatch(GetSiteString());
	};

	return (
		<Card>
			<CardHeader title="GreenPlum Site List" />
			<Divider />
			<CardContent>
				<Button className={classes.generate} onClick={_generate} variant="contained">Generate</Button>
			</CardContent>
		</Card>
	);
};

export default SiteString;
